import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";

export const loginService = async data => {
  return publicRequest.post(ConfEnv.API_URL.URL_LOGIN, data);
};

export const recoverPasswordService = async email => {
  return publicRequest.post(`${ConfEnv.API_URL.URL_RECOVER_PASSWORD}/${email}`);
};
